module.exports = __webpack_public_path__ + "static/contentP3-be5e19e0ecace7589ae8ee28f808ee5f.png";